import React from 'react'
import {
  arrayOf,
  func,
  number,
  objectOf,
  oneOfType,
  shape,
  string,
} from 'prop-types'
import { Select, Tooltip } from 'components/atoms'
import * as Styled from './MultiSelectRow.styles'

/**
 * create a row of select elements
 * @param selectedValues
 * @param selectData
 * @param onAdditionalSelectChange
 * @returns {JSX.Element}
 * @constructor
 */
const MultiSelectRow = ({
  selectedValues,
  selectData,
  onAdditionalSelectChange,
}) => {
  const selectWrapperClass = { 1: 'one', 2: 'two', 3: 'three' }
  return (
    <Styled.AdditionalSearchSelects>
      {selectData.map((select, key) => (
        <div
          key={ key }
          id={ `${ select.typ }-select-wrapper` }
          className={ `select-wrapper ${ selectWrapperClass[selectData.length] }` }
          data-cy-select-wrapper={ select.typ }>
          <div className='select-headline'>
            <div className='select-label'>{select.label}</div>
            {select?.tooltip && (
              <Tooltip
                tooltipId={ `${ select.typ }-tooltip` }
                infoIconId={ `${ select.typ }-icon` }
                arrow='left'
                dialogTitle={ select.tooltip.title }>
                {select.tooltip.tip}
              </Tooltip>
            )}
          </div>

          <Select
            id={ select.typ }
            data-cy={ select.typ }
            handleSelect={ (value) =>
              onAdditionalSelectChange(select.typ, value)
            }
            value={ selectedValues[select.typ] }
            className='additional-searchbar-selects'
            options={ select.options.map((option) => ({
              value: option.value,
              option: option.label,
            })) }
            placeholder='Bitte wählen'
            excludeCurrentValue
          />
        </div>
      ))}
    </Styled.AdditionalSearchSelects>
  )
}

MultiSelectRow.propTypes = {
  selectedValues: objectOf(string),
  selectData: arrayOf(
    shape({
      typ: string.isRequired,
      label: string.isRequired,
      preSelect: string,
      tooltip: shape({
        title: string.isRequired,
        tip: string.isRequired,
      }),
      options: arrayOf(
        shape({
          label: string.isRequired,
          value: oneOfType([string, number]).isRequired,
        })
      ),
    })
  ),
  onAdditionalSelectChange: func.isRequired,
}

export default MultiSelectRow
